import styled, { css } from 'styled-components';
import { AvatarSize } from './enums';
import { StyledAvatarProps } from './types';

const SIZE: Record<AvatarSize, string> = {
  [AvatarSize.Small]: '2.625rem',
  [AvatarSize.Medium]: '4.25rem',
  [AvatarSize.Big]: '5.7rem',
};

const ICON_SIZE: Record<AvatarSize, string> = {
  [AvatarSize.Small]: '1.5rem',
  [AvatarSize.Medium]: '2rem',
  [AvatarSize.Big]: '2.6875rem',
};

export const StyledAvatar = styled.div<StyledAvatarProps>`
  border-radius: 100%;
  background-color: var(--paper-2);
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  color: var(--ink-2);
  height: ${({ size = AvatarSize.Medium }) => SIZE[size]};
  width: ${({ size = AvatarSize.Medium }) => SIZE[size]};
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  ${({ noBorder }) =>
    !noBorder &&
    css`
      border: 1px solid rgba(9, 15, 56, 0.12);
    `}

  > img {
    border-radius: 100%;
  }

  a:hover & {
    box-shadow: 0 0 0 3px rgba(118, 177, 89, 0.22);
    transform: scale(1.02);
  }

  svg {
    height: 1em;
    width: 1em;
    font-size: ${({ size = AvatarSize.Medium }) => ICON_SIZE[size]};
    fill: currentColor;
  }
`;

export const StyledAvatarImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  display: block;
`;

export const StyledAvatarPlaceholder = styled.div<{ $bg?: string; $color?: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $bg }) => $bg || 'var(--muted-3)'};
  color: ${({ $color }) => $color || 'var(--surface)'};
`;

export const StyledAvatarPlaceholderText = styled.span<StyledAvatarProps>`
  color: inherit;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  font-size: ${({ size = AvatarSize.Medium }) =>
    `calc(${SIZE[size]} * 0.3)`};
`;
